module.exports = __webpack_public_path__ + "img/spartan-demolition-sitework-04.76283b14.jpg";